module.exports = __webpack_public_path__ + "static/media/map-marker-vaccination-places.dbb0ce27.svg";